import { CdnService } from '@/common/services/cdn/cdn.service';
import { RefundPolicyResponse } from '@/core/domain/refund-policy/models/refund-policy-response.model';
import { RefundPolicyRepository } from '@/core/domain/refund-policy/repositories/refund-policy.respository';
import { TranslationsGetLanguageUseCase } from '@/core/domain/translation/usecases/translations-get-language.usecase';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class RefundPolicyImplRepository extends RefundPolicyRepository {
    constructor(
        private readonly http: HttpClient,
        private readonly getLanguageUseCase: TranslationsGetLanguageUseCase,
    ) {
        super();
    }

    override getRefundPolicy(): Observable<RefundPolicyResponse> {
        return this.http.get<RefundPolicyResponse>(
            CdnService.url(
                'refund-policy-json/' +
                    this.getLanguageUseCase.execute().language +
                    '.json',
            ),
        );
    }
}
